import { useEffect } from "react";
import { useIsMobile } from "./useMediaQuery";

/**
 * На мобилке — PWA-класс (admin-app-mode / client-app-mode).
 * На десктопе — desktop-portal, без мобильных переопределений.
 */
export function usePortalHtmlClass(mode) {
  const isMobile = useIsMobile(768);
  const pwaClass = mode === "client" ? "client-app-mode" : "admin-app-mode";

  useEffect(() => {
    const root = document.documentElement;
    if (isMobile) {
      root.classList.add(pwaClass);
      root.classList.remove("desktop-portal");
    } else {
      root.classList.remove(pwaClass);
      root.classList.add("desktop-portal");
    }
    return () => {
      root.classList.remove(pwaClass);
      root.classList.remove("desktop-portal");
    };
  }, [isMobile, pwaClass]);
}
